const TYPE = 'STAR_WEB_PRINT';

export default {
    ENABLE_KEY: TYPE + '_ENABLE',
    HOST_KEY: TYPE + '_HOST_KEY',
    PORT_KEY: TYPE + '_PORT_KEY',
}



// WEBPACK FOOTER //
// ./src/view/constant/printer/StarWebPrintConstant.js